<template>
  <div class="accordion" v-bind:class="{'active' : active}">
    <div class="header" v-on:click="toggleAccordion()">
      <div class="title col-5">
        <slot name="title"></slot>
      </div>
      <div class="warning">
        <span>
          <slot name="titleWarning"></slot>
        </span>
      </div>
      <div class="iconAccordion">
        <font-awesome-icon v-if="!active" icon="angle-down" />
        <font-awesome-icon v-if="active" icon="angle-up" />
      </div>
    </div>
    <div class="body">
      <slot name="body" v-if="!lazyBody || hasBeenOpened"></slot>
    </div>
  </div>
</template>
<script>
const accordionInstances = new WeakMap();
let nearbyObserver = null;

function getNearbyObserver() {
  if (nearbyObserver || typeof IntersectionObserver === "undefined") {
    return nearbyObserver;
  }

  nearbyObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const instance = accordionInstances.get(entry.target);
        if (instance) {
          instance.preloadNearbyImages();
        }

        nearbyObserver.unobserve(entry.target);
      });
    },
    {
      // Começa a baixar um pouco antes de a linha aparecer na tela. Assim a
      // imagem tende a estar no cache quando o usuário abre o accordion, sem
      // carregar as centenas de máquinas que ficaram longe da visualização.
      rootMargin: "800px 0px"
    }
  );

  return nearbyObserver;
}

export default {
  name: "accordion",
  props: {
    /**
     * Adia a montagem do conteúdo até a primeira abertura. Numa lista longa
     * (um inventário chega a centenas de máquinas) o corpo fechado continua no
     * DOM e o navegador baixa todas as imagens dele, mesmo sem ninguém abrir.
     */
    lazyBody: {
      type: Boolean,
      default: false
    },
    preloadImages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      active: false,
      hasBeenOpened: false
    };
  },
  mounted() {
    if (!this.lazyBody) return;

    const observer = getNearbyObserver();
    if (observer) {
      accordionInstances.set(this.$el, this);
      observer.observe(this.$el);
    }
  },
  beforeDestroy() {
    if (nearbyObserver && this.$el) {
      nearbyObserver.unobserve(this.$el);
      accordionInstances.delete(this.$el);
    }
  },
  methods: {
    toggleAccordion() {
      this.active = !this.active;
      // Depois de aberto uma vez, o conteúdo fica montado para não perder o
      // que o usuário digitou ao fechar e reabrir.
      if (this.active) {
        this.hasBeenOpened = true;
        this.preloadNearbyImages();
      }
    },
    preloadNearbyImages() {
      this.preloadImages
        .filter(Boolean)
        .forEach(url => {
          const image = new Image();
          image.src = url;
        });
    }
  }
};
</script>

<style lang="scss">
.accordion {
  margin-bottom: 12px;
  .header {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px 20px;
    border: 0.5px solid #e9eaee;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .warning {
      position: absolute;
      right: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      // padding: 5px 8px;
      border: 1px solid transparent;
      border-radius: 8px;
      background-color: #fef2e9;
    }
    .iconAccordion {
      position: absolute;
      right: 20px;
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .header:hover {
    cursor: pointer;
  }
  .body {
    padding: 20px 20px;
    border: 0.5px solid #e9eaee;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: 0;
    width: 100%;
    display: none;
  }

}
.accordion.active {
  > .body {
     display: block 
  }
}
</style>
